import informationTypeApi from "../../api/informationType";
import { AppThunkActionAsync } from "..";
import { StoreState } from "../storeState";
import * as actions from "./actions";
import {
  selectAvailableInformationTypesState,
  selectInformationTypePermissionSet,
  selectInformationTypePermissionsState,
} from "./selectors";

export function getAvailableInformationTypes(): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectAvailableInformationTypesState(getState());
    if (state === StoreState.Loading || state === StoreState.Loaded) {
      return;
    }

    dispatch(actions.availableFetchRequest());
    try {
      const response = await informationTypeApi.getAvailable();
      dispatch(actions.availableFetchSuccess(response.data));
    } catch {
      dispatch(actions.availableFetchError());
    }
  };
}

export function getInformationTypePermissions(
  roleId: number
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectInformationTypePermissionsState(getState());
    const permissionSet = selectInformationTypePermissionSet(getState());
    if (
      state === StoreState.Loading ||
      (state === StoreState.Loaded && permissionSet?.roleId === roleId)
    ) {
      return;
    }

    dispatch(actions.permissionsFetchRequest());
    try {
      const response = await informationTypeApi.getPermissions({ roleId });
      dispatch(actions.permissionsFetchSuccess(response.data));
    } catch {
      dispatch(actions.permissionsFetchError());
    }
  };
}
